<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom: 60px">
              <div class="search-wrap">
                <div class="search-item">
                  <label class="col-sm-2 control-label"> Title </label>
                  <div class="col-sm-4">
                    <el-input v-model="searchParams.title" clearable></el-input>
                  </div>
                  <div class="btn-wrap">
                    <el-button @click="getMenuList" type="primary">{{
                      $t("message.Search")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row table-responsive">
                <div class="col-xs-12 add-btn">
                    <el-button @click="handleNavToDetail" icon="el-icon-plus" type="primary">Add</el-button>
                    <el-button @click="showWarning">Delete</el-button>
                </div>
            </div>
            <div class="row table-responsive" style="padding-bottom: 60px">
              <div class="col-xs-12">
                {{ total }}{{ $t("message.datagridresult") }}
              </div>
              <el-table
                :data="menuList"
                style="width: 100%"
                ref="multipleTable"
                :fit="true"
                class="rowss"
                row-key="id"
                @selection-change="handleSelectionChange"
              >
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  label="Title"
                  prop="title"
                  :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column label="Action" width="80" fixed="right">
                  <template slot-scope="scope">
                    <el-row>
                      <el-col :span="12">
                        <el-button @click="handleNavToDetail(scope.row)" type="primary" size="mini">Detail</el-button>
                      </el-col>
                    </el-row>
                  </template>
                </el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10, 20, 50, 100, 200]"
                  :page-size="searchParams.pageSize"
                  :total="total"
                  style="float: right"
                >
                </el-pagination>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <el-dialog
      title=""
      :visible.sync="selectCaptchaDlg"
      width="70%"
      :append-to-body="true"
      center
    >
      <div class="form-group">
        <img :src="captcha.captchaImage" />
      </div>
      <div class="form-group">
        <el-input v-model="answer"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="form-group">
          <el-button @click="selectCaptchaDlg = false">Cancel</el-button>
          <el-button type="primary" @click="syncEvent()">Confirm</el-button>
        </div>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import config from "../config";
import axios from "axios";
import Sortable from "sortablejs";

export default {
  mixins: [config.globalMixin],
  components: {},
  data() {
    return {
      searchParams: {
        pageSize: 10,
        pageIndex: 1,
        sortName: "",
        sortType: "",
        title: "",
      },
      menuList: [],
      total: 0,
      multipleSelection:[]
    };
  },
  computed: {
    baseURL() {
      return config.domain + "/";
    },
    userInfo() {
      return this.getAuthObj();
    },
  },
  created() {},
  mounted() {
    this.intiPage();
  },
  methods: {
    intiPage() {
      this.getMenuList();
      const table = document.querySelector(
        ".rowss .el-table__body-wrapper tbody"
      );
      const self = this;
      Sortable.create(table, {
        onEnd({ newIndex, oldIndex }) {
          self.updateListSort(newIndex, oldIndex);
        },
        filter: ".disabled",
        onMove: (event) => {
          return !event.related.classList.contains("disabled");
        },
      });
    },
    async updateListSort(newIndex, oldIndex) {
      const item = this.menuList[oldIndex];
      this.menuList.splice(oldIndex, 1);
      this.menuList.splice(newIndex, 0, item);
      const lstOrderDTO = this.menuList.map((i) => {
        return {
          id: i.id,
          displayOrder: i.sortOrder,
        };
      });
      const param = {
        lstOrderDTO,
        ...this.userInfo,
      };
      const {
        data: { status_code, status_message },
      } = await axios.post(this.baseURL + "websiteElearningMenu/order", {
        ...param,
      });
      if (status_code == "0") {
        this.getMenuList();
      } else {
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    async getMenuList() {
      const {
        data: { result, status_code, status_message },
      } = await axios.post(this.baseURL + "websiteElearningMenu/list", {
        ...this.userInfo,
        ...this.searchParams,
      });
      if (status_code == "0") {
        this.total = result.total;
        this.menuList = result.menuList;
      } else {
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    handleSizeChange(val) {
      this.searchParams.pageSize = val;
      this.getMenuList();
    },
    handleCurrentChange(val) {
      this.searchParams.pageIndex = val;
      this.getMenuList();
    },
    handleNavToDetail(row) {
      this.$router.push({
        path: "/main/editWebsiteMenu",
        query: {
          id: row.id,
        },
      });
    },
    handleSelectionChange(val){
      this.multipleSelection = val.map(i=>{
        return i.id
      });
    },
    async deleteList(){
      if(!this.multipleSelection.length) return
      const ids=this.multipleSelection.reduce((total,item,index)=>{
        if(index==this.multipleSelection.length-1) return total+item
        return total +item +","
      },'')
      const params = {
        ids,
        ...this.userInfo
      }
      const formData = new FormData()
      Object.keys(params).forEach(i=>{
        formData.append(i,params[i])
      })
      const {data:{status_code,status_message}}=await axios.post(this.baseURL +'websiteElearningMenu/delete',formData)
      if(status_code=='0') {
        this.getMenuList();
      }else{
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.add-btn{
    display:flex;
    justify-content: flex-end;
}
.search-wrap{
    display:flex;
    flex-direction: column;
    .search-item{
        margin-bottom:15px;
        display:flex;
        .entry-no-wrap{
          display:flex;
          .separator{
            margin:0 10px;
            display:flex;
            align-items: center;
          }
        }
        .btn-wrap{
            display:flex;
            justify-self: flex-end;
        }
    }
}
</style>
